import { FormattedMessage, defineMessage } from 'react-intl'
import { Wrapper } from 'routes/ThankYou/styles'
import Text from 'components/shared/Text'
import ImageInfoBox from 'components/shared/ImageInfoBox'
import * as LINKS from 'constants/links'
import { useApp } from 'store/steps'
import { useResolutions } from 'store/resolutions'
import villagePhoto from 'assets/images/thankYou/villagePhoto.png'
import villagePhotoMobile from 'assets/images/thankYou/villagePhoto_mobile.png'

type ThankYouStayLongerProps = {
    withLineBreak?: boolean
}

export const ThankYouStayLonger = ({
    withLineBreak,
}: ThankYouStayLongerProps) => {
    const { language } = useApp()
    const { isTablet } = useResolutions()

    return (
        <Wrapper
            gap={24}
            align={['center', 'flex-start']}
            justify={'space-between'}
            isLongTitle={language === 'en'}
        >
            <Text
                variant="heading2"
                color="grayscale_900"
                align={['center', 'left']}
            >
                <FormattedMessage
                    id="order.thankyou.suntago_village_tile_heading_part_1"
                    defaultMessage="A może"
                />{' '}
                {withLineBreak && <br />}
                <Text as="span" color="primary_500" variant="heading2">
                    <FormattedMessage
                        id="order.thankyou.suntago_village_tile_heading_part_2"
                        defaultMessage="dłuższy pobyt?"
                    />
                </Text>
            </Text>
            <ImageInfoBox
                image={isTablet ? villagePhotoMobile : villagePhoto}
                imageAlt="Suntago Village"
                title={defineMessage({
                    id: 'order.thankyou.suntago_village_tile_subheading',
                    defaultMessage: 'Suntago Village',
                })}
                desc={defineMessage({
                    id: 'order.thankyou.suntago_village_tile_message',
                    defaultMessage:
                        'Suntago Village to miejsce dla wielbicieli zabawy i tropikalnego klimatu, chcących dłużej cieszyć się pobytem w Parku.',
                })}
                linkText={defineMessage({
                    id: 'global.btn.more',
                    defaultMessage: 'Więcej',
                })}
                linkUrl={LINKS.ACCOMMODATION_LINK}
                testId="page-thankyou-redirect-restaurants"
            />
        </Wrapper>
    )
}
